import { useContext, useEffect, useRef, useState } from "react";
import { Users, TrendingUp, BarChart3, Calendar } from "lucide-react";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import Skeleton from "@mui/material/Skeleton";
// import InnerLoader from "../../../component/ui/loader/inner-loader";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../component/table/table-layout";
import { CustomDropdown } from "../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../component/ui/dropdown/CustomDropdownMenuList";
// import WorkForceQuickView from "./popup";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  KPI,
  TitleHeading,
} from "../../../component/ui/layout";
// import { FeildWraper, FormArea } from "../../../component/form/form-layout";
// import Picker from "react-month-picker";
// import "react-month-picker/css/month-picker.css";
import moment from "moment";
import { GlobalContext } from "../../../context/Context";
import { FeildWraper } from "../../../component/form/form-layout";
import StatusChip from "../../../component/ui/chip/status";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import Style from "./style.module.css";
import DataNotFound from "../../../component/ui/loader/data-not-found";

// const MONTHS = [
//   "Jan", "Feb", "Mar", "Apr",
//   "May", "Jun", "Jul", "Aug",
//   "Sep", "Oct", "Nov", "Dec"
// ];

// const FULLMONTHS = [
//   "",
//   "January", "February", "March", "April",
//   "May", "June", "July", "August",
//   "September", "October", "November", "December"
// ];

// --- Main Component ---
export default function OrganizationDashboard() {
  // let data = "";
  let { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const [dashboardData, setDashboardData] = useState({});
  const [isDashboardApiLoaded, setIsDashboardApiLoaded] = useState(false);

  const [selectedMonth, setSelectedMonth] = useState(
    moment(new Date()).format("YYYY-MM"),
  );
  const [defaultMonthOption, setDefaultMonthOption] = useState("");
  const [teams, setTeams] = useState([]);

  const getDashboardData = async () => {
    setIsDashboardApiLoaded(false);
    try {
      const resp = await apiCall({
        method: "get",
        url: `get-manager-overview?date_range=${defaultMonthOption || selectedMonth}`,
      });
      setDashboardData(resp);
      setIsDashboardApiLoaded(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getTeams = async () => {
    try {
      const res = await apiCall({ method: "get", url: `teams/get-user-teams` });
      console.log("getTeams", res);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const getUsers = async (team) => {
    try {
      const res = await apiCall({
        method: "get",
        url: `teams/get-team-user-by-team-id${team ? `/${team}` : ""}`,
      });
      console.log("getUsers", res);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getTeams();
    getUsers();
  }, []);

  useEffect(() => {
    getDashboardData();
  }, [selectedMonth, defaultMonthOption]);

  // LINE CHART

  const inputRef = useRef();

  const openMonthPicker = () => {
    if (inputRef.current?.showPicker) {
      inputRef.current.showPicker();
    } else {
      inputRef.current?.focus();
      inputRef.current?.click();
    }
  };

  return (
    <>
      <div className="pt-[20px] h-full overflow-hidden">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          {/* Header */}
          <div className="flex items-center justify-between">
            {/* <TitleHeading>Manager Overview</TitleHeading> */}
            <div>
              <h1 className="text-2xl font-bold">Manager Overview</h1>
            </div>
            <div className="flex gap-3 flex-shrink-0 w-fit items-center justify-end">
              <FeildWraper className={"!w-fit !flex-[0_0_auto] !pl-0 !py-0"}>
                <div className="relative">
                  <input
                    type="month"
                    ref={inputRef}
                    className="absolute opacity-0 pointer-events-none"
                    max={moment(new Date()).format("YYYY-MM")}
                    value={selectedMonth}
                    onChange={(e) => {
                      setDefaultMonthOption("");
                      setSelectedMonth(e.target.value);
                    }}
                  />

                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown"
                  >
                    <CustomDropdownButton arrow={false} className="btnClass">
                      <h3 className="!text-[16px] px-5 py-1 capitalize flex items-center gap-1">
                        <Calendar className="!w-4 !h-4" />
                        {defaultMonthOption
                          ? defaultMonthOption?.replaceAll("_", " ")
                          : moment(selectedMonth, "YYYY-MM").format(
                              "MMMM YYYY",
                            )}
                      </h3>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">
                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("this_month");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          This Month
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("last_month");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Last Month
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("this_year");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          This Year
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("last_year");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Last Year
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList onClick={openMonthPicker}>
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Custom Month
                        </div>
                      </CustomDropdownMenuList>
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </div>
              </FeildWraper>
              {/* <Tooltip
                                className={Style.bpfl_actionItems}
                                content={"Filter"}
                                position={"left center"}
                            >
                                <div
                                    className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                                        }`}
                                    onClick={() => {
                                        setShowModalFilterTable(true);
                                    }}
                                >
                                    <div className={Style.icon}>
                                        <FilterFunnel01Icon />
                                    </div>
                                </div>
                            </Tooltip> */}
            </div>
          </div>

          {/* KPI Row */}
          <TableCard className={" h-full flex "}>
            {/* !p-[15px] !pr-[7px] */}

            <div className="flex flex-col gap-6">
              <div className="">
                <div className="pb-4">
                  <TitleHeading>Follow Ups</TitleHeading>
                </div>
                 <div className="p-5 h-[400px]  bg-white border border-[#E1E4EA] shadow-card rounded-[10px] overflow-hidden">

                <TableCard>
                  {isDashboardApiLoaded ? (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Name</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Type</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Client</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Agent</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Activity Subject</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Activity Type</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Priority</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Due Date</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Overdue Days</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Note</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Status</span>
                            </TableHeaderWrap>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {dashboardData?.followUps?.length ? (
                          dashboardData?.followUps?.map((eachPlat, i) => (
                            <TableRow key={i}>
                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.name || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.type || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.client || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.agent || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.activity_subject || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.activity_type || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.activity_priority || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.due_date || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.overdue_days || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  <span>{eachPlat?.activity_note || "-"}</span>
                                </TableHeaderWrap>
                              </TableCell>

                              <TableCell>
                                <TableHeaderWrap>
                                  {/* <span>{eachPlat?.activity_status ? <StatusChip color={eachPlat?.activity_status == "completed" ? "green" : (eachPlat?.activity_status == "cancelled") ? "red" : (eachPlat?.activity_status == "overdue") ? "yellow" : "blue"}>{eachPlat?.activity_status}</StatusChip> : ""}</span> */}
                                  <span>
                                    {eachPlat?.activity_status ? (
                                      <span
                                        className="inline-flex py-[4px] px-[12px] rounded-[6px] text-[10px] font-bold uppercase"
                                        style={
                                          eachPlat?.activity_status?.toLowerCase() ==
                                          "completed"
                                            ? {
                                                background: "#e8f5e9",
                                                color: "#388e3c",
                                              }
                                            : eachPlat?.activity_status?.toLowerCase() ==
                                                "pending"
                                              ? {
                                                  background: "#dbe0f5",
                                                  color: "#335CFF",
                                                }
                                              : eachPlat?.activity_status?.toLowerCase() ==
                                                  "overdue"
                                                ? {
                                                    background: "#fff3e0",
                                                    color: "#e65100",
                                                  }
                                                : {
                                                    background: "#fff3e0",
                                                    color: "#e65100",
                                                  }
                                        }
                                      >
                                        {eachPlat.activity_status}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </TableHeaderWrap>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={99}>
                              <DataNotFound
                                title={"Data"}
                                className={"text-center"}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  ) : (
                    <div className="flex justify-center items-center h-full">
                      <InnerLoader />
                    </div>
                  )}
                </TableCard>
                 </div>
              </div>

              <div className="">
                <div className="pb-4">
                  <TitleHeading>Metrics</TitleHeading>
                </div>
                 <div className="p-5 h-[400px]  bg-white border border-[#E1E4EA] shadow-card rounded-[10px] overflow-hidden">

                <TableCard>
                  {isDashboardApiLoaded ? (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Report/Peroid</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Total Calls</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>New Leads</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Avg. Deal Size</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Conversions</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Conversion Rate</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell header>
                            <TableHeaderWrap>
                              <span>Revenue Closed</span>
                            </TableHeaderWrap>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <TableHeaderWrap>
                              <span>{"Daily"}</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {dashboardData?.metrics?.today?.["Total Calls"]}
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {dashboardData?.metrics?.today?.["New Leads"]}
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.today?.[
                                    "Avg. Deal Size"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {dashboardData?.metrics?.today?.["Conversions"]}
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.today?.[
                                    "Conversion Rate"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.today?.[
                                    "Revenue Closed"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            <TableHeaderWrap>
                              <span>{"Weekly"}</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_week?.[
                                    "Total Calls"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_week?.[
                                    "New Leads"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_week?.[
                                    "Avg. Deal Size"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_week?.[
                                    "Conversions"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_week?.[
                                    "Conversion Rate"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_week?.[
                                    "Revenue Closed"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            <TableHeaderWrap>
                              <span>{"Monthly"}</span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_month?.[
                                    "Total Calls"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_month?.[
                                    "New Leads"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_month?.[
                                    "Avg. Deal Size"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_month?.[
                                    "Conversions"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_month?.[
                                    "Conversion Rate"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>

                          <TableCell>
                            <TableHeaderWrap>
                              <span>
                                {
                                  dashboardData?.metrics?.this_month?.[
                                    "Revenue Closed"
                                  ]
                                }
                              </span>
                            </TableHeaderWrap>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  ) : (
                    <div className="flex justify-center items-center h-full">
                      <InnerLoader />
                    </div>
                  )}
                </TableCard>
                 </div>
              </div>
            </div>
          </TableCard>
        </div>
      </div>
    </>
  );
}
